<div class="form-group">
  <label for="prod-m">{{ 'form.company'| translate }}</label>
  <angular2-multiselect [data]="list"
      [(ngModel)]="companySelected"
      [settings]="multiselectSettings[EMULTI_SELECT_SETTING.NO_SEARCH]"
      [disabled]="disabled"
      (onSelect)="onElementSelect()">
  </angular2-multiselect>
</div>